import * as api from "$helper/api";
import { apiPrefix } from "../serviceConstants";

export const getPaymentHandler = (companyId: string) => {
    return api.get<string>(`${apiPrefix.companies}/${companyId}/payment-handler`);
};

export default getPaymentHandler;
